<template>
  <div class="cont" id="cont3">
    <div class="inner">
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
        style="height:35px;width:160px;margin-left:116px;margin-bottom:12px"
        :src="require('@/assets/image/home/home3/img1.png')"
        :fit="fit"
      ></el-image>
      <router-link :to="{ path: '/variousproducts/brakePads'  }">
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
          style="height:22px;width:112px;margin-left:97px;margin-bottom:9px"
          :src="require('@/assets/image/home/home3/img2.png')"
          :fit="fit"
        ></el-image>
      </router-link>
      <router-link :to="{ path: '/variousproducts/brakedisc'  }">
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
          style="height:22px;width:112px;margin-left:83px;margin-bottom:12px"
          :src="require('@/assets/image/home/home3/img3.png')"
          :fit="fit"
        ></el-image>
      </router-link>

      <router-link :to="{ path: '/variousproducts/brakecalipers'  }">
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
          style="height:22px;width:137px;margin-left:69px;margin-bottom:9px"
          :src="require('@/assets/image/home/home3/img4.png')"
          :fit="fit"
        ></el-image>
      </router-link>


      <router-link :to="{ path: '/variousproducts/brakeOil'  }">
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
          style="height:22px;width:112px;margin-left:55px;margin-bottom:12px;display:block"
          :src="require('@/assets/image/home/home3/img5.png')"
          :fit="fit"
        ></el-image>
      </router-link>  

      <router-link :to="{ name: 'Other' }">
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
          style="height:22px;width:136px;margin-left:41px;margin-bottom:32px;display:block"
          :src="require('@/assets/image/home/home3/img6.png')"
          :fit="fit"
        ></el-image>
      </router-link>

      <!-- <el-image
        :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
        style="height:22px;width:136px;margin-left:38px;margin-bottom:32px;"
        :src="require('@/assets/image/home/home3/img7.png')"
        :fit="fit"
      ></el-image>  -->
      <router-link :to="{ name: 'Brake' }">
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
          style="height:29px;width:137px;margin-left:12px;margin-bottom:0px;"
          :src="require('@/assets/image/home/home3/img8.png')"
          :fit="fit"
        ></el-image> 
      </router-link>



    </div>
  </div>
</template>

<script>
export default {
  name: "ContThree" ,
  data() {
    return {
      fit:  'cover' ,
      animate : false , 
      screenHeight: window.innerHeight || document.documentElement.clientHeight ,

    }
  } ,
  mounted () {
    // 事件监听滚动条
    window.addEventListener('scroll', this.watchScroll)
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    var topPos = document.getElementById("cont3").offsetTop;
    if( scrollTop + this.screenHeight >  topPos ){
      this.animate = true 
    }
  },
  destroyed(){
    window.removeEventListener('scroll', this.watchScroll);
  },
  methods: {
    watchScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      var topPos = document.getElementById("cont3").offsetTop;
      if( scrollTop + this.screenHeight >  topPos  ){
        this.animate = true 
      }
    }
  } ,
};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  height: 368px;
  background-color: pink;
  color: #fff;
  margin: 0 auto;
  position: relative;
  background: url("~@/assets/image/home/home3/bg.png");
  background-repeat : no-repeat 
  background-size : cover
}

.inner {
  position: absolute;
  width: 276px;
  height: 285px;
  right: 151px;
  top: 41px;
}
</style>